var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.47,
    height: 16,
    viewBox: "0 0 13.47 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.46,4.11c0-.42,0-.85,0-1.23a.57.57,0,0,0-.56-.57h0A7.75,7.75,0,0,1,7.13.15a.58.58,0,0,0-.78,0A7.69,7.69,0,0,1,.6,2.31.57.57,0,0,0,0,2.88H0c0,.38,0,.81,0,1.23-.08,4-.18,9.52,6.51,11.85a.58.58,0,0,0,.18,0,.28.28,0,0,0,.18,0c6.73-2.33,6.63-7.82,6.57-11.85Zm-4,2.73L6.37,9.94a.59.59,0,0,1-.4.16.71.71,0,0,1-.4-.16L4,8.4a.56.56,0,0,1,.79-.79L6,8.76,8.68,6.05a.57.57,0,0,1,.79,0,.56.56,0,0,1,0,.79Z",
    fill: "#aca6fe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.7e40b02f606c9cececa8131b7a8f00ea.svg";
export { ForwardRef as ReactComponent };